import { ProfileGetterTypes } from './types';

export const getters = {
    [ProfileGetterTypes.GetProfile](state, { profile }) {
        return state.profile = profile
    },
}